import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import Loader from "./Loader";
import { useDispatch } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";

const CancelSession = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [timeZone, setTimeZone] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const dispatch = useDispatch();
  const { user } = authContext;
  const navigate = useNavigate();

  const userId = user?.userId || user?.data?.data?.userId;

  const myZone = localStorage.getItem("zone");

  var isMentor = localStorage.getItem("userId") === data?.mentor_id;
  useEffect(() => {
    getTimeZone();
  }, []);

  const getTimeZone = async () => {
    // const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const timeZone = await axiosHttp.get(`timezone`);
      if (timeZone.status === 200) {
        let data = timeZone?.data?.data;
        const myTimeZone = data.find((item) => {
          const { utc } = item;
          return utc.includes(myZone);
        });
        setTimeZone(myTimeZone?.utc[0]);
        setLoading(false);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  const cancelSessionHandler = async () => {
    setIsSubmit(true);
    let payload = {};
    if (data.service_name === "Single session") {
      payload = { comment: reason, zone: timeZone };
    } else {
      payload = {
        comment: reason,
        oldStartTime: data.start_time,
        oldEndTime: data.end_time,
      };
    }
    try {
      const getCancenSession = await axiosHttp.post(
        isMentor
          ? `cancallation-request/${data.id}`
          : // : data.service_name === "Single session"
            `appointments/${data.id}/cancel`,
        // : `cancel-appointment/${data.id}/weekly`,
        { ...payload }
      );
      if (getCancenSession.status === 201) {
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
        appContext.updateModalState();
        setIsSubmit(false);
        if (data.service_name === "Single session") {
          navigate("../myspace/schedule");
        }
      }
    } catch (e) {
      let { response } = e;
      setLoading(false);
      if (response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        setLoading(false);
        appContext.updateModalState();
      }
      if (response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
    setIsSubmit(false);
  };

  return loading ? (
    <Loader />
  ) : isSubmit ? (
    <div className="join-session-modal">
      <div className="modal-body" style={{ marginTop: "40px" }}>
        <p>
          Your cancellation request has been initiated, please wait while we are
          processing...
        </p>
      </div>
    </div>
  ) : (
    <div>
      <div className="modal-body">
        <div className="form-group">
          <lable>Reason</lable>
          <select
            className="form-control"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Select</option>
            <option value=" No longer interested in the session">
              {" "}
              No longer interested in the session
            </option>
            <option value="Expert not available">Expert not available</option>
            <option value=" Personal reasons">Personal reasons</option>
            <option value="Application interface issue">
              Application interface issue
            </option>
            <option value=" Found another expert">Found another expert</option>
            <option value=" Expertise request for cancellation">
              Expertise request for cancellation
            </option>
            <option value="Others">Others</option>
          </select>
        </div>
        {/* <div className="form-group">
          <div>
            <lable>Detailed comment</lable>
            <textarea className="form-control" rows={5} cols={20}></textarea>
          </div>
        </div> */}
      </div>
      <div className=" mt-4 mb-5">
        <div className=" d-flex justify-content-between align-items-center w-100 p-10 testimonials-wrapper">
          <div>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn"
              onClick={() => appContext.updateModalState()}
            >
              Don’t Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn"
              data-dismiss="modal"
              disabled={reason === "" && true}
              onClick={cancelSessionHandler}
            >
              Cancel Session
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelSession;
